import "./App.css";
import { Suspense, type JSX, useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { AppProviders } from "@/app/providers/AppProviders";
import { router } from "@/routes"
import { Toaster } from "@/components/ui/sonner.tsx";
import { useAuthStore } from "@/stores/use-auth-store.ts";
import * as Sentry from "@sentry/react";
import {ErrorFallback} from "@/components/error/error-fallback.tsx";

function App(): JSX.Element {
  const initializeDeviceId = useAuthStore((state) => state.initializeDeviceId);

  useEffect(() => {
    initializeDeviceId();
  }, [initializeDeviceId])

  return (
    <AppProviders>
      <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
        <Suspense fallback={null}>
          <RouterProvider router={router}/>
          <Toaster />
        </Suspense>
      </Sentry.ErrorBoundary>
    </AppProviders>
  );
}

export default App;
